export const navLinks = [
  { label: "The unit", href: "#unit" },
  { label: "What’s included", href: "#included" },
  { label: "Questions", href: "#questions" },
];

export const stats = [
  { value: "12", label: "Ready-to-teach lessons" },
  { value: "5", label: "Bonus resources included" },
  { value: "45 min", label: "40-min adaptation" },
  { value: "$27", label: "One-time · USD" },
];

export const teachSteps = [
  {
    title: "Open it",
    text: "Open the book at the lesson for the day — each one is laid out on its own.",
  },
  {
    title: "Look",
    text: "Look over the session plan, the station layout and what you’ll need.",
  },
  {
    title: "Teach",
    text: "Head into the gym and lead the lesson, adapting it for your group.",
  },
];

export const specRows = [
  { term: "Main guide", detail: "One original 40-page teaching guide" },
  { term: "Lessons", detail: "12 lessons of 45 minutes, with a 40-minute adaptation" },
  { term: "Pacing", detail: "Teach in sequence or space lessons around your timetable" },
  { term: "Age group", detail: "Ages 8–12" },
  { term: "Language", detail: "English" },
  { term: "Format", detail: "Digital resources only. No physical product" },
];

export const phases = [
  {
    number: "01",
    title: "Build the foundations",
    summary: "The unit opens by setting up the habits everything else depends on.",
    focus: ["Routines", "Stick control", "Passing and receiving"],
  },
  {
    number: "02",
    title: "Put skills into practice",
    summary: "Early skills move into more active, varied formats around the space.",
    focus: ["Station-based activities", "Movement", "Target practice"],
  },
  {
    number: "03",
    title: "Bring it together",
    summary: "Skills combine as students start reading the game and working together.",
    focus: ["Decision-making", "Teamwork", "Small-sided play"],
  },
];

export const sessionPoints = [
  {
    title: "Visible session structure",
    text: "Each lesson is planned with a clear start, main activity and close, so the shape of the session is easy to follow at a glance.",
  },
  {
    title: "Equipment-aware planning",
    text: "Planning takes realistic school equipment into account. The station-map bonus is designed around 12 sticks and 30 students.",
  },
  {
    title: "Teacher-led adaptations",
    text: "Notes help you adjust for class size, available space and the needs of your group. Your professional judgment leads.",
  },
];

export const bonuses = [
  {
    title: "Station Maps: 12 Sticks / 30 Students",
    description:
      "Layouts for organising stations when you have 12 sticks for a class of 30 students.",
  },
  {
    title: "Safety Posters & Stop Signals",
    description:
      "Posters for displaying key safety reminders and the signals used to stop and reset activity.",
  },
  {
    title: "Editable Assessment & Progress Tracker",
    description:
      "An editable tracker for recording your observations and students’ progress across the unit.",
  },
  {
    title: "Four 20-Minute Replacement Lessons",
    description: "Four shorter sessions for days when a full-length lesson isn’t possible.",
  },
  {
    title: "School Hockey Festival Kit",
    description:
      "Resources to help you organise a school floor-hockey festival to round off the unit.",
  },
];

export const faqs = [
  {
    question: "Who is this for?",
    answer:
      "School teachers leading beginner floor hockey with students aged 8–12. You’ll adapt it to your class size, available space and the needs of your learners.",
  },
  {
    question: "Can I adapt the pacing?",
    answer:
      "Yes. Teach the 12 lessons in sequence or space them around your timetable. Adapt the pace to your group and revisit skills when needed.",
  },
  {
    question: "How long is each lesson?",
    answer: "Each lesson is planned for 45 minutes, with a 40-minute adaptation.",
  },
  {
    question: "What equipment will I need?",
    answer:
      "Appropriate school hockey sticks, soft balls, cones or markers, a suitable space and adult supervision. The included station-map bonus is designed around 12 sticks and 30 students. Equipment is not supplied.",
  },
  {
    question: "Is this field hockey or competitive rules hockey?",
    answer:
      "No. This is a beginner school floor-hockey unit using teacher-led, modified activities. It is not a field-hockey or federation-rule curriculum.",
  },
  {
    question: "What safety approach does the unit use?",
    answer:
      "Beginner activities use soft-ball push passes and empty cone targets, with no goalkeepers, no contact, no stick-to-stick tackling and no slap shots, and sticks kept below waist height. Teachers must follow school policy, check equipment and space, supervise activities and adapt for their group. This approach is not a safety guarantee.",
  },
  {
    question: "Is this a physical product?",
    answer:
      "No. The bundle contains digital teaching resources only. No physical equipment is included.",
  },
  {
    question: "Where do I purchase?",
    answer:
      "Use “Get the Kit” to open the Impul checkout. Review your order details and available payment methods there before completing your purchase.",
  },
];
